<script setup lang="ts">
import Swal from 'sweetalert2'
import type { DeptProperties } from '@/pages/erp/du/org/db/du-dept-types'
definePage({
})

interface Emit {
  (e: 'editData', value: DeptProperties): void
  (e: 'deleteData', value: DeptProperties): void
  (e: 'enableData', value: DeptProperties): void
}

interface Props {
  upperDepNo?: string
  triggerSearch?: number
}

const props = defineProps<Props>()
const emit = defineEmits<Emit>()

const compId = ref(useStorage('compNo').value)

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
  { title: '', key: 'data-table-expand', width: '50px' },
  { title: '單位名稱', key: 'depName', width: '150px' },
  { title: '標籤', key: 'orgType', width: '100px' },
  { title: 'Email', key: 'email' },
  { title: '電話', key: 'phone' },
  { title: '狀態', key: 'status', width: '50px' },
  { title: '操作', key: 'actions', sortable: false, width: '200px'}
]

const upperDepNo = ref(props.upperDepNo)

// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: subDeptData, execute: fetchSubDept, isFetching: loading  } = await useApi<any>(createUrl('/du/org/class/getSubDept', {
  query: {
    upperDepNo
  },
}))

const datas = computed((): DeptProperties[] => subDeptData.value.map((it: { id: string; depNo: string; }) => {
  it.id = it.depNo
  return it
}))

console.log('datas: ', datas)

watch(props, (val) => {
  fetchSubDept()
})

const editData = (deptData: DeptProperties) => {
  emit('editData', deptData)
}

// 👉 Delete data
const deleteData = async (event: Event,deptData: DeptProperties) => {
  emit('deleteData', deptData)
  // 阻止事件冒泡
  event.stopPropagation();
}

// 👉 Enable data
const enableData = async (event: Event, deptData: DeptProperties) => {
  emit('enableData', deptData)
  // 阻止事件冒泡
  event.stopPropagation();
}


const updateExpanded = (expanded: any) => {
  console.log('updateExpanded: ', expanded)

  expanded.forEach((it: string) => {
    // fetchSubDepts(it)
  })

}

const orgText = (orgType: string) => {
  switch (orgType) {
    case 'A':
      return '協會'
    case 'C':
      return '中心'
    case 'T':
      return '隊伍'
    default:
      return orgType
  }
}

const statusText = (status: string) => {
  switch (status) {
    case 'CA':
      return '作廢'
    case 'OP':
      return '正常'
    default:
      return '正常'
  }
}

</script>

<template>
  <VDataTableServer
    :items="datas"
    :headers="grid1Headers"
    :items-per-page="datas.length"
    :loading="loading"
    class="text-no-wrap"
    expand-on-click
    @update:expanded="updateExpanded"
    show-expand
    hide-default-footer
  >
    <template v-slot:headers="{}"></template>
    <template #expanded-row="slotProps">
      <tr>
        <td colspan="8">
          <du-sub-org :upper-dep-no="slotProps.item.depNo" @edit-data="editData" @delete-data="deleteData" @enable-data="enableData" />
        </td>
      </tr>
    </template>
    <template #item.id="{ item, index }">
      <div class="text-body-1 text-high-emphasis">
        {{ index + 1 }}
      </div>
    </template>
    <template #item.orgType="{ item }">
      <VChip class="rounded-pill" :color="item.orgType == 'A' ? 'warning' : item.orgType == 'T' ? 'success' : 'info'" variant="flat">
        {{ orgText(item.orgType) }}
      </VChip>
    </template>
    <template #item.status="{ item }">
      <VChip class="rounded-pill" :color="item.status == 'CA' ? 'error' : 'success'" variant="flat">
        {{ statusText(item.status) }}
      </VChip>
    </template>


    <!-- Actions -->
    <template #item.actions="{ item }">
      <VBtn
        variant="outlined"
        density="compact"
        style="margin-right: 10px;"
        @click="editData(item)"
      >
        編輯
      </VBtn>
      <VBtn v-if="item.status=='CA'"
        variant="outlined"
        density="compact"
        style="margin-right: 10px;"
        @click="enableData($event,item)"
      >
        啟用
      </VBtn>
      <VBtn v-else
        variant="outlined"
        density="compact"
        style="margin-right: 10px;"
        @click="deleteData($event,item)"
      >
        作廢
      </VBtn>
    </template>

    <!-- pagination -->
    <template #bottom>
<!--      <TablePagination-->
<!--        v-model:page="currentPage"-->
<!--        v-model:size="size"-->
<!--        :items-per-page="size"-->
<!--        :total-items="totalDatas"-->
<!--      />-->
    </template>
  </VDataTableServer>
  <!-- 👉 Edit -->

</template>
